import styled from "@emotion/styled";
import { MdsCard } from "@/design-system/components/card/MdsCard";

export const OAuthCardWrapper = styled(MdsCard)`
  flex-grow: 0;
  width: 420px;
  min-width: 420px;
  height: 520px;
  min-height: 520px;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 36px;
  border-radius: ${({ theme }) => theme.borderRadius.large + "px"};
  overflow: hidden;
  /**
   * On desktop, the outer region is draggable.
   * We want to ensure this card is not draggable.
   */
  -webkit-app-region: no-drag;
`;
